// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"_9330de7794--image-wrapper--VqeOq"};